module.exports = __webpack_public_path__ + "05740cc15961e501034309fe16b87cef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/biometric.svg
// module id = 732
// module chunks = 0